import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Just Rôle It';
const DEFAULT_DESCRIPTION = "Just Rôle It, association de jeu de rôle sur table et en ligne à Herblay-sur-Seine. Ici, on ne raconte pas des histoires. On les vit !";
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_roleplay-hub-30/artifacts/5y3hduhe_JRI%20LOGO.jpg';

const SEO = ({ title, description = DEFAULT_DESCRIPTION, image = DEFAULT_IMAGE, path = '', type = 'website', noIndex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Association de Jeu de Rôle`;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const url = `${origin}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content="fr_FR" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
